import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import { useStores } from '../../store/rootStore';
import ContinueButton from '../../common/continueButton';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { MotivationType } from '../../store/motivationStore';
import { trackOnboardingCollectedMotivations } from '../../utils/analytics';

export type ButtonInputTypes = {
  title: string;
  image: string;
};

const CollectMotivations = observer(() => {
  const { motivationStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedMotivations(
      Array.from(motivationStore.selectedMotivations),
    );
    navigate(getNextPagePath('CollectMotivations'));
  };

  const handleClick = (selectedMotivation: MotivationType) => {
    motivationStore.toggleMotivation(selectedMotivation);
  };

  return (
    <Container>
      <ProgressBar currentPage="CollectMotivations" />
      <PageHeader title="What motivates your exercise?"></PageHeader>
      <Flex direction={'column'}>
        {motivationStore.motivationOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            image={option.image}
            onClick={() => handleClick(option.value)}
            isSelected={motivationStore.selectedMotivations.has(option.value)}
          />
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={motivationStore.selectedMotivations.size < 1}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectMotivations;
